import { USER_TYPES } from "../../UserList/utils/userConfigs";

export const tabConfig = [
  {
    label: "MTD Target",
    value: "mtd_target",
  },
  {
    label: "YTD Target",
    value: "ytd_target",
  },
];

export const geoEntityTabs = [
  {
    label: "Me",
    value: null,
  },
  {
    label: "Circles",
    value: "circle",
  },
  {
    label: "Zones",
    value: "zone",
  },
  {
    label: "Areas",
    value: "area",
  },
  {
    label: "Territories",
    value: "territory",
  },
  {
    label: "Distribution Houses",
    value: "agency",
  },
];

export const geoHierarchy = {
  circle: 1,
  zone: 2,
  area: 3,
  territory: 4,
  agency: 5,
};

export const geoHierarchyLabelMap = {
  circle: "Circle",
  zone: "Zone",
  area: "Area",
  territory: "Territory",
  agency: "Distributor",
};

export const user2GeoEntityMap = {
  [USER_TYPES.BKASH_SUPER_USER]: "circle",
  [USER_TYPES.CIRCLE_HEAD]: "circle",
  [USER_TYPES.REGIONAL_MANAGER]: "zone",
  [USER_TYPES.AREA_MANAGER]: "area",
  [USER_TYPES.TERRITORY_MANAGER]: "territory",
  [USER_TYPES.AGENCY_USER]: "agency",
};

export const getNextGeoEntityByUserType = (userType) => {
  if (userType === USER_TYPES.BKASH_SUPER_USER) {
    return "circle";
  }

  const currentGeoEntity = user2GeoEntityMap[userType];

  if (!currentGeoEntity) {
    return null;
  }

  const currentHierarchyLevel = geoHierarchy[currentGeoEntity];

  if (!currentHierarchyLevel) {
    return null;
  }

  const nextEntity = Object.entries(geoHierarchy).find(
    ([, level]) => level === currentHierarchyLevel + 1
  );

  return nextEntity?.[0] || null;
};

export const getPluralizedLabel = (label, count) => {
  if (!label) return label;

  const singularToPlural = {
    Circle: "Circles",
    Zone: "Zones",
    Area: "Areas",
    Territory: "Territories",
    Distributor: "Distributors",
  };

  const pluralToSingular = Object.entries(singularToPlural).reduce(
    (acc, [sing, plur]) => {
      acc[plur] = sing;
      return acc;
    },
    {}
  );

  if (count === 1) {
    return pluralToSingular[label] || label;
  } else {
    return singularToPlural[label] || label;
  }
};

export const getLeaderboardLabelByHierarchy = (entity) => {
  const labelMap = {
    circle: "Circles/Circle Heads",
    zone: "Zones/Regional Managers",
    area: "Areas/Area Managers",
    territory: "Territories/Territory Managers",
    agency: "DH/DH Users",
  };
  return labelMap[entity] || "Hierarchy Heads";
};

export const getHierarchyListByUserType = (userType) => {
  const isSuperUser = userType === USER_TYPES.BKASH_SUPER_USER;
  if (isSuperUser) {
    return geoEntityTabs;
  }
  const userHierarchy = user2GeoEntityMap[userType];
  const userHierarchyLevel = geoHierarchy[userHierarchy] + 1;
  if (userHierarchyLevel < geoEntityTabs.length) {
    const subordinateHierarchies = geoEntityTabs.slice(
      userHierarchyLevel,
      geoEntityTabs.length
    );
    return [geoEntityTabs[0], ...subordinateHierarchies];
  } else {
    return [geoEntityTabs[0]];
  }
};

export const getSortFieldLabel = (sortField) => {
  if (!sortField) return "";
  const labels = {
    ach_pct: "Ach % sorted",
    growth_pct: "Growth % sorted",
    achievement: "Achievement sorted",
    target: "Target sorted",
  };
  return labels[sortField] || sortField;
};

export const getSortOrderLabel = (sortDir) => {
  if (!sortDir) return "";
  return sortDir === "asc" ? "low to high" : "high to low";
};
